import { novaClient } from "@/lib/trpc";

// The user's citable paper trail, grouped: fieldCitations (canonical user
// fields) and shiftCitations (each carrying which shift it is about). Newest
// conversation first within each group, capped per cited target.
export const useGetPaperTrailCitations = ({
  enabled = true,
  userId,
}: {
  enabled?: boolean;
  userId: number;
}) => {
  return novaClient.internal.user.paperTrail.citationsForUser.useQuery(
    { userId },
    {
      // Hosts that derive the worker id from another query pass 0 while
      // it loads don't fire a request for a user that can't exist.
      enabled: enabled && userId > 0,
    },
  );
};
